<template>
    <div class="pages" :class="{ 'mobile': classObj.mobile, isMobileHidePerson }">
        <van-nav-bar class="navBar" :title="''" :left-text="$t('lang.back')" left-arrow :border="false"
            @click-left="goBack">
            <template #left>
                <div class="left_back">
                    <img src="@/assets/signIn/back.png" alt="" draggable="false">
                    <div>{{ $t('lang.back') }}</div>
                </div>
            </template>
        </van-nav-bar>
        <div class="user_info">
            <div class="user_box">
                <img :src="$themeImage('person.avatar')">
                <div>
                    <div class="phone">
                        <span class="phone-txt">Hi,{{ userPhone }}</span>
                        <div v-if="!classObj.mobile" class="reg-time">Fecha de registro：{{ userInfo.registerTime }}</div>
                        <div class="icon_logout" @click.stop="handleLogout">
                            <img :src="$themeImage('person.logout')" />
                        </div>
                    </div>
                    <div class="user_id" @click.stop="copyText(userInfo.id)">
                        ID: {{ userInfo.id }}
                        <img :src="$themeImage('person.copy')" />
                    </div>
                    <div v-if="classObj.mobile" class="reg-time">Fecha de registro：{{ userInfo.registerTime }}</div>
                    <div v-if="!classObj.mobile" class="totalData">
                        <div>
                            <div>{{ $t("MyProfile.TotalBet") }}</div>
                            <div>
                                {{ formatCurrency(userInfo.grandTotalBetting || 0) }}
                            </div>
                        </div>
                        <div>
                            <div>{{ $t("MyProfile.TotalBonus") }}</div>
                            <div>
                                {{ formatCurrency(userInfo.grandTotalBouns || 0) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="user_btns">
                <div @click="toDeposit">
                    {{ $t("deposit.Deposit") }}
                </div>
                <div @click="toWithdraw">
                    {{ $t("Withdraw.Withdraw") }}
                </div>
            </div>
        </div>
        <div class="main-content-wrap">
            <div class="menus">
                <div class="menus-item" :class="{ 'menuAct': menuAct === 'Person' }" @click.stop="toPerson">
                    <span class="text">Centro personal</span>
                </div>
                <div class="menus-item" :class="{ 'menuAct': menuAct === 'RedemptionRecords' }"
                    @click.stop="toRedemptionRecords">
                    <span class="text">{{ $t("RedemptionCode.RedemptionRecord") }}</span>
                </div>
                <div v-if="invitationPageRewardState === 'enable'" class="menus-item" :class="{ 'menuAct': menuAct === 'Transaction' }" @click.stop="toTransaction">
                    <span class="text">{{ $t("person.Transaction") }}</span>
                </div>
                <div class="menus-item" :class="{ 'menuAct': menuAct === 'History' }" @click.stop="toBetHistory">
                    <span class="text">{{ $t("person.History") }}</span>
                </div>
                <div class="menus-item" :class="{ 'menuAct': menuAct === 'ChangePwd' }" @click.stop="toChangePwd">
                    <span class="text">{{ $t("Setting.changePwd") }}</span>
                </div>
                <div class="menus-item" :class="{ 'menuAct': menuAct === 'Language' }" @click.stop="toLanguage">
                    <span class="text"> {{ langType }}</span>
                </div>
                <div class="menus-item" @click="toServer">
                    <span class="text">{{ $t("person.LiveChat") }}</span>
                </div>
                <div class="menus-item" @click.stop="toDownApp">
                    <span class="text">{{ $t("person.Install") }}</span>
                </div>
            </div>
            <div class="main-content-box">
                <router-view ref="routerView" />
            </div>
        </div>
        <loginPopup @loginSucc="init"></loginPopup>
        <logoutPopup ref="logoutPopup"></logoutPopup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { Toast } from 'vant'
import handleCopy from '@/utils/copy.js'
import logoutPopup from '@/components/logoutPopup'
export default {
    name: 'Person',
    components: { logoutPopup },
    computed: {
        isLogin() {
            return !!this.$store.getters.token
        },
        userInfo() {
            return this.$store.getters.userInfo
        },
        userPhone() {
            const phone = this.userInfo && this.userInfo.phone
            return phone ? this.maskNumber(phone) : ''
        },
        // userMoney() {
        //     // const userInfo = this.$store.getters.userInfo
        //     const info = {
        //         balanceAmtAccount: this.allBalance
        //         // bonusAmtAccount: userInfo.balanceAmtAccount ? userInfo.bonusAmtAccount.useBalance.toFixed(2) : '0.0'
        //     }
        //     return info
        // },
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            const obj = {
                mobile: this.device === 'mobile'
            }
            // const meta = this.$route.meta
            // console.log(meta, 'meta')
            // if (meta) {
            //     const isMobileHidePerson = meta.isMobileHidePerson
            //     obj.isMobileHidePerson = isMobileHidePerson
            // }
            return obj
        },
        sysConfig() {
            return this.$store.getters.sysConfig
        },
        langType() {
            return this.langObj[this.$store.getters.language].name || 'English'
        },
        invitationPageRewardState() {
            return this.$store.getters.userInfo && this.$store.getters.userInfo.invitationPageRewardState
        }
    },
    data() {
        return {
            menuAct: 'Person',
            isMobileHidePerson: false
        }
    },
    methods: {
        init() {
            const that = this
            const child = that.$refs.routerView
            if (that.menuAct === 'Person') child.init()
        },
        maskNumber(phoneNumber) {
            const str = phoneNumber.toString()
            if (str.length <= 4) {
                return str
            }
            const firstTwo = str.slice(0, 2)
            const lastTwo = str.slice(-2)
            return `${firstTwo}***${lastTwo}`
        },
        copyText(content) {
            handleCopy(
                {
                    content,
                    success: (msg) => {
                        Toast(msg)
                    },
                    error: (msg) => {
                        Toast(msg)
                    }
                },
                this
            )
        },
        handleLogout() {
            this.$refs.logoutPopup.open()
        },
        toLogin(type) {
            this.$store.dispatch('user/changeLoginType', type)
            this.$store.dispatch('user/setIsShowLoginPopup', true)
        },
        toDeposit() {
            if (this.$route.path.indexOf('/wallet?type=deposit') !== -1) {
                return
            }
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toWithdraw() {
            if (this.$route.path.indexOf('/wallet?type=Withdraw') !== -1) {
                return
            }
            const params = { type: 'Withdraw' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toBetHistory() {
            this.$router.push('/PersonBox/History')
        },
        toTransaction() {
            this.$router.push('/PersonBox/Transaction')
        },
        toVIP() {
            if (this.$route.path.indexOf('/vip') !== -1) {
                return
            }
            this.onNavToByIsLogin({ url: '/vip' })
        },
        toSetting() {
            if (this.$route.path.indexOf('/setting') !== -1) {
                this.$store.dispatch('user/setIsShowMyPopup', false)
                return
            }
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavTo({ url: '/setting' })
        },
        onShowDownAppPopup() {
            this.$store.dispatch('user/setIsShowDownAppPopup', true)
        },
        toShare() {
            if (this.$route.path.indexOf('/affiliate') !== -1) {
                this.$store.dispatch('user/setIsShowMyPopup', false)
                return
            }
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavTo({ url: '/affiliate' })
        },
        toServer() {
            this.onNavTo({ url: '/notification?type=0' })
        },
        toNotification() {
            this.onNavTo({ url: '/notification?type=1' })
        },
        toPerson() {
            // this.onNavTo({ url: '/personBox' })
            this.$router.push({ path: '/personBox' })
        },
        toRedemptionRecords() {
            this.$router.push('/PersonBox/RedemptionRecords')
        },
        toChangePwd() {
            this.$router.push('/PersonBox/ChangePwd')
        },
        toLanguage() {
            this.$router.push('/PersonBox/Language')
        },
        toDownApp() {
            this.$router.push('/PersonBox/DownApp')
        }
    },
    watch: {
        $route: {
            handler: function (to, from) {
                // this.act = ''
                // this.subAct = ''
                // const opt = this.$route?.params
                // if (opt && opt.params) {
                //     const params = JSON.parse(decodeURIComponent(opt?.params))
                //     this.act = params?.code
                //     if (params.gameTitleId) this.subAct = params.gameTitleId
                // }
                const meta = this.$route.meta
                this.isMobileHidePerson = meta.isMobileHidePerson
                this.menuAct = this.$route.name
            },
            deep: true,
            immediate: true
        }
        // classObj(newVal) {
        //     if (!newVal.mobile) {
        //         this.onPageRefresh()
        //     }
        // }
    }
}
</script>
<style lang="scss" scoped>
@import '@/common/styles/viriables.scss';

.pages {
    box-sizing: border-box;
    width: 92%;
    margin: .6rem auto .5rem auto;
    padding: .45rem .6rem .6rem .6rem;
    position: relative;
    background-image: var(--theme-common-frame-corner-top-left),
        /* 左上角 */
        var(--theme-common-frame-corner-top-right),
        /* 右上角 */
        var(--theme-common-frame-corner-bottom-left),
        /* 左下角 */
        var(--theme-common-frame-corner-bottom-right);
    /* 右下角 */

    /* 四个角位置 ↓ 一一对应 */
    background-position: left top,
        right top,
        left bottom,
        right bottom;

    /* 不重复 */
    background-repeat: no-repeat;

    /* 图片大小（根据你需求调整） */
    background-size: 2.25rem 1.5rem;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
        background-image:
            var(--theme-frame-line-vertical),
            var(--theme-frame-line-vertical);
        background-position: left center, right center;
        background-size: 0.04rem 100%, 0.04rem 100%;
        background-repeat: no-repeat;
    }

    &::after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
        background-image:
            var(--theme-frame-line-horizontal),
            var(--theme-frame-line-horizontal);
        background-position: center top, center bottom;
        background-size: 100% 0.04rem, 100% 0.04rem;
        background-repeat: no-repeat;
    }

    &.mobile {
        // min-width: 100%;
        // height: 100vh;
        width: calc(100% - .1rem);
        padding: 0 .28rem;
        display: flex;
        flex-direction: column;
        margin: .08rem;
        padding-bottom: .38rem;

        &::after {
            background-size: 40% 0.04rem, 40% 0.04rem;
        }

        .van-nav-bar {
            display: none;
        }

        .user_info {
            width: 100%;

            .user_box {
                margin-bottom: 0;
                padding: .48rem 0;
                width: 100%;

                >img {
                    width: 1.3rem;
                    height: 1.3rem;
                    margin-right: .18rem;
                }

                >div {
                    padding-right: 0;
                    align-items: flex-start;

                    >div {
                        &.phone {
                            width: 100%;
                            margin-bottom: 0;
                            justify-content: space-between;
                            margin-top: -.08rem;

                            .phone-txt {
                                font-size: .3rem;
                                line-height: .4rem;
                            }

                            .reg-time {
                                display: none;
                            }
                        }

                        &.user_id {
                            height: .28rem;
                            line-height: .28rem;
                            font-size: .22rem;
                            margin-bottom: .18rem;

                            img {
                                width: .24rem;
                                height: .24rem;
                            }
                        }

                        &.totalData {
                            display: none;
                        }
                    }
                }
            }

            .user_btns {
                display: none;
            }
        }

        .main-content-wrap {
            padding: .3rem 0 .1rem 0;
            border-top: 0;
            padding-top: 0;

            .menus {
                display: none;
            }
        }

        &.isMobileHidePerson {
            padding: 0;
            background: transparent !important;
            box-sizing: border-box;
            height: 100vh;
            margin: 0;
            width: 100%;
            padding: 0 .18rem;
            padding-top: 1.2rem;

            .user_info {
                display: none;
            }

            .main-content-wrap {
                padding: 0;
                height: 100%;

                .main-content-box {
                    height: 100%;
                }
            }

            &::before {
                display: none;
            }

            &::after {
                display: none;
            }
        }
    }

    .van-nav-bar {
        background: transparent;

        .left_back {
            display: flex;
            align-items: center;
            font-size: .32rem;

            >img {
                width: 0.48rem;
                height: 0.48rem;
                margin-right: .24rem;
            }
        }
    }

    .user_info {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .user_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            margin-bottom: .2rem;
            padding: .16rem .22rem;

            .icon_logout {
                width: .58rem;
                height: .58rem;
                border-radius: .02rem;
                position: relative;
                right: auto;
                top: auto;
                transform: none;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                flex: none;
                margin-left: .16rem;

                &>img {
                    width: .48rem;
                    height: .48rem;
                    vertical-align: middle;
                    filter: brightness(1.2) sepia(.18);
                }
            }

            >img {
                width: 1.5rem;
                height: 1.5rem;
                margin-right: .2rem;
            }

            >div {
                flex: 1;
                min-width: 0;
                padding-right: .16rem;
                display: flex;
                flex-direction: column;
                justify-content: center;

                >div {
                    &.phone {
                        margin-bottom: .02rem;
                        display: flex;
                        align-items: center;

                        .reg-time {
                            margin-left: .2rem;
                        }

                        .phone-txt {
                            font-size: .45rem;
                            line-height: .48rem;
                            color: var(--theme-bright-text);
                            font-weight: 700;
                        }
                    }

                    &.totalData {
                        display: flex;
                        align-items: center;
                        color: var(--theme-soft-text);
                        font-size: .26rem;

                        &>div {
                            display: flex;
                            align-items: flex-end;
                            margin-right: .38rem;

                            &>div:last-child {
                                color: var(--theme-bright-text);
                                font-size: .3rem;
                                margin-left: .08rem;
                            }
                        }
                    }

                    &.user_id {
                        height: .3rem;
                        line-height: .3rem;
                        color: var(--theme-soft-text);
                        font-size: .24rem;
                        display: flex;
                        align-items: center;
                        gap: .06rem;
                        text-align: left;
                        justify-content: flex-start;
                        margin-bottom: .1rem;

                        i {
                            cursor: pointer;
                            color: $font-person-accent-color;
                        }

                        img {
                            width: .26rem;
                            height: .26rem;
                            vertical-align: middle;
                        }
                    }
                }

                .reg-time {
                    width: auto;
                    display: inline-block;
                    border: .01rem solid var(--theme-surface-border);
                    border-radius: .06rem;
                    font-size: .22rem;
                    padding: .02rem .18rem;
                    margin: 0;
                    color: var(--theme-soft-text);
                }
            }
        }

        .user_btns {
            display: flex;
            justify-content: flex-end;

            &>div {
                width: 1.88rem;
                height: .68rem;
                border-radius: .12rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: .26rem;
                cursor: pointer;

                &:first-child {
                    background: $bg-btn-color;
                    color: $font-btn-color;
                    margin-right: .3rem;
                }

                &:last-child {
                    box-sizing: border-box;
                    border: .01rem solid transparent;
                    background-image:
                        linear-gradient(to right, var(--theme-popup-box-bg), var(--theme-popup-box-bg)),
                        linear-gradient(90deg, var(--theme-popup-box-border), var(--theme-popup-box-border));
                    background-origin: border-box;
                    background-clip: content-box, border-box;
                    box-shadow: var(--theme-popup-box-shadow);
                }
            }
        }
    }

    .main-content-wrap {
        width: 100%;
        border-top: 1px solid var(--theme-surface-border);
        position: relative;
        padding: .3rem 0 .1rem 290px;
        min-height: 500px;

        .menus {
            position: absolute;
            left: 0;
            top: .3rem;
            width: 270px;
            padding: .18rem .16rem;
            border-radius: .24rem;
            color: var(--theme-bright-text);
            font-size: .26rem;
            background: var(--theme-surface-bg);

            .menus-item {
                height: .78rem;
                line-height: .78rem;
                text-align: left;
                position: relative;
                background: rgba(0, 0, 0, 0.10);
                cursor: pointer;
                border-radius: .2rem;
                margin-bottom: .16rem;
                padding: 0 .18rem;

                &:last-child {
                    margin-bottom: 0;
                }

                &>i {
                    font-size: .44rem;
                    vertical-align: middle;
                    margin-right: .2rem;
                    color: $font-sub-color;
                }

                &:after {
                    content: '';
                    width: .17rem;
                    height: .17rem;
                    border-top: .02rem solid $font-title-color;
                    border-right: .02rem solid $font-title-color;
                    position: absolute;
                    right: .36rem;
                    top: calc(50% - .01rem);
                    transform: rotate(45deg) translateY(-50%);
                }

                &.menuAct {
                    background: var(--theme-active-bg);
                    color: var(--theme-active-text);
                }
            }
        }

        .main-content-box {
            width: 100%;
            min-height: 520px;
        }
    }
}</style>
